import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceButton } from '../components/ChoiceButton';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
import { FlaskConical, Factory, Network, Activity } from 'lucide-react';
interface Props {
  onSelect: (value: string) => void;
  selectedValue?: string;
}
const options = [{
  id: 'translation',
  label: 'Scientific translation',
  icon: FlaskConical
}, {
  id: 'manufacturing',
  label: 'Manufacturing readiness',
  icon: Factory
}, {
  id: 'workflow',
  label: 'Workflow coordination',
  icon: Network
}, {
  id: 'scalability',
  label: 'Clinical scalability',
  icon: Activity
}];
export function SlideHook({
  onSelect,
  selectedValue
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-20 pb-28" data-id="element-486">
      <MolecularBackdrop variant="nodes" data-id="element-487" />

      <div className="relative z-10 flex-1 flex flex-col justify-center" data-id="element-488">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-489">
          <span className="text-minerva-blue text-[10px] font-bold tracking-[0.25em] uppercase mb-4 block" data-id="element-490">
            Industry Pulse · 01
          </span>
          <h1 className="text-[28px] font-display font-bold text-slate-900 leading-[1.15] mb-8" data-id="element-491">
            What is becoming the biggest bottleneck in radiopharmaceutical
            development?
          </h1>
        </motion.div>

        <div className="flex flex-col gap-3" data-id="element-492">
          {options.map((opt, i) => <ChoiceButton key={opt.id} label={opt.label} icon={opt.icon} selected={selectedValue === opt.id} onClick={() => onSelect(opt.id)} delay={0.2 + i * 0.1} data-id="element-493" />)}
        </div>
      </div>
    </motion.div>;
}